import FormItem from "@components/formItem";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import React from "react";
import MaskInput from "react-maskinput";
import { Box, Content, ContentTitle, MaskedInput, MaskedInputLabel } from "../baseItems";
import Base from "./base";

export default class Centralpay extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			showCardMask: false,
			showShabaMask: false,
			cardNumber: "",
			shabaNumber: "",
			cardNumberValue: "",
			shabaNumberValue: "",
			canForward: false,
		};
		this.cardInputRef = React.createRef();
		this.shabaInputRef = React.createRef();
	}

	componentDidMount() {
		this.checkRequiredFields();
		super.componentDidMount();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevState.cardNumber !== this.state.cardNumber ||
			prevState.shabaNumber !== this.state.shabaNumber ||
			prevState.cardNumberValue !== this.state.cardNumberValue ||
			prevState.shabaNumberValue !== this.state.shabaNumberValue ||
			prevState.stake !== this.state.stake ||
			prevState.selectedCurrency !== this.state.selectedCurrency
		) {
			this.checkRequiredFields();
		}
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
		const inputRef = field === "showCardMask" ? this.cardInputRef : this.shabaInputRef;
		if (inputRef.current) {
			const value = inputRef.current.input.value;
			const position = value.indexOf("_") !== -1 ? value.indexOf("_") : value.length;
			inputRef.current.input.setSelectionRange(position, position);
		}
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("show", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "").trim();
		this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
	};

	checkRequiredFields = () => {
		const { cardNumberValue, shabaNumberValue, stake, selectedCurrency } = this.state;

		if (cardNumberValue && shabaNumberValue && stake && selectedCurrency) {
			this.setState({ canForward: true });
		} else {
			this.setState({ canForward: false });
		}
	};

	getStep1(translate) {
		const {
			selectedCurrency,
			showCardMask,
			showShabaMask,
			cardNumber,
			shabaNumber,
			cardNumberValue,
			shabaNumberValue,
		} = this.state;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				{this.getCurrencyField(translate)}
				{this.getStakeField(null, false)}
				{this.renderMinMax()}
				{selectedCurrency && (
					<BoxWrapper>
						<FormItem onRegister={() => this.registerField({ name: "cardNumber" })}>
							<Box>
								<MaskedInput>
									<MaskInput
										ref={this.cardInputRef}
										alwaysShowMask={window.IS_MARS ? true : false}
										onFocus={() => this.handleFocus("showCardMask")}
										onBlur={(e) =>
											this.handleBlur("showCardMask", e.target.value)
										}
										maskChar={showCardMask ? "_" : ""}
										mask="0000 0000 0000 0000"
										size={16}
										onChange={(e) => this.onEnterValue("cardNumber", e)}
										value={showCardMask ? cardNumber : cardNumberValue}
									/>
									<MaskedInputLabel
										isFocused={showCardMask}
										hasValue={cardNumberValue}>
										{translate("CREDIT_CARD")}
									</MaskedInputLabel>
								</MaskedInput>
							</Box>
						</FormItem>
						<FormItem onRegister={() => this.registerField({ name: "shabaNumber" })}>
							<Box>
								<MaskedInput>
									<MaskInput
										ref={this.shabaInputRef}
										alwaysShowMask={window.IS_MARS ? true : false}
										onFocus={() => this.handleFocus("showShabaMask")}
										onBlur={(e) =>
											this.handleBlur("showShabaMask", e.target.value)
										}
										maskChar={showShabaMask ? "_" : ""}
										mask="000000000000000000000000"
										size={24}
										onChange={(e) => this.onEnterValue("shabaNumber", e)}
										value={showShabaMask ? shabaNumber : shabaNumberValue}
									/>
									<MaskedInputLabel
										isFocused={showShabaMask}
										hasValue={shabaNumberValue}>
										{translate("SHABA NUMBER")}
									</MaskedInputLabel>
								</MaskedInput>
							</Box>
						</FormItem>
					</BoxWrapper>
				)}
			</Content>
		);
	}

	goForward(step) {
		const { stake, selectedCurrency } = this.state;
		const { selectedWithdraw } = this.props;

		if (!this.state.canForward) return;

		const currency = selectedWithdraw.currencies.find(
			(item) => item.currency === selectedCurrency
		);

		if (currency && stake < currency.withdraw.min) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MIN",
				title: "ERROR",
			});
			return;
		}

		if (currency && stake > currency.withdraw.max) {
			this.props.showAlert({
				type: "error",
				msg: "STAKE_RANGE_WARNING_MAX",
				title: "ERROR",
			});
			return;
		}

		const newStep = step + 1;
		this.setState({ currentStep: newStep });
	}

	makeExternalPayment() {
		const { stake, cardNumberValue, shabaNumberValue, selectedCurrency } = this.state;
		const { cryptoCurrency } = this.props;
		let withdrawData = {
			type: "Centralpay",
			amount: {
				value: Number(stake),
				currency: selectedCurrency ? selectedCurrency : "EUR",
			},
			cardNumber: cardNumberValue,
			shabaNumber: shabaNumberValue,
			language: this.getActiveLanguageCode(),
			note: new Date(),
			cryptoCurrencyType: cryptoCurrency,
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}

	render() {
		const { canForward } = this.state;
		return super.render();
	}
}
